import React, { useMemo } from 'react'
import { CustomInputMappingField, getFilterConditionField, JsonDataType } from '@tuqqi/common'


export const useFilterConditionField = (fields: CustomInputMappingField[], fieldsData: JsonDataType, businessId?: string) => { 
    const filterConditionField = useMemo(() => getFilterConditionField(fields, fieldsData, businessId), [businessId, fields, fieldsData])

    return [filterConditionField]
}
